import { SortFindManyTaskInput } from '@tools/ui/types/generated/graphql';

enum InboxFilterMapperEnum {
  isPaymentExpedited = 'entityCachedData.features.isPaymentExpedited',
  reason = 'entityCachedData.riskEngineDecision.reason',
  paymentUserEmail = 'entityCachedData.payment.createdByEmail',
  clientIpAgeForOrganization = 'entityCachedData.features.clientIpAgeForOrganization',
  clientIpAgeForUser = 'entityCachedData.features.clientIpAgeForUser',
  isFRR = 'entityCachedData.features.isFRR',
  isPaymentOriginSafe = 'entityCachedData.features.isPaymentOriginSafe',
  fundingSourceType = 'entityCachedData.features.fundingSourceType',
  fundingSourceId = 'entityCachedData.fundingSourceId',
  paymentCreatedAt = 'entityCachedData.payment.createdAt',
  deliveryMethodType = 'entityCachedData.deliveryMethod.deliveryType',
  deliveryMethodCreatedAt = 'entityCachedData.deliveryMethod.createdAt',
  scheduledDate = 'entityCachedData.payment.scheduledDate',
  amount = 'entityCachedData.payment.amount',
  paymentCreateOrigin = 'entityCachedData.payment.createOrigin',
  paymentPartner = 'entityCachedData.payment.createdByPartner.companyName',
  organizationPartner = 'entityCachedData.organization.partner.partnerName',
  vendorCompanyName = 'entityCachedData.vendor.companyName',
  vendorId = 'entityCachedData.vendor.id',
  organizationCompanyName = 'entityCachedData.organization.companyName',
  organizationTaxId = 'entityCachedData.organization.taxId',
  organizationTaxIdType = 'entityCachedData.organization.taxIdType',
  organizationId = 'entityCachedData.organization.id',
  organizationDecision = 'entityCachedData.organization.decision',
  isFinanced = 'entityCachedData.payment.isFinanced',
  organizationKybStatus = 'entityCachedData.organization.kybStatus',
  organizationKybMoneyIn = 'entityCachedData.organization.kybMoneyIn',
  organizationKybMoneyInSubType = 'entityCachedData.organization.kybMoneyInSubType',
  isMelioMeVendor = 'entityCachedData.features.vendorHasHandle',
  noteToSelf = 'entityCachedData.bill.note',
  noteToVendor = 'entityCachedData.payment.note',
  paymentId = 'entityCachedData.payment.id',
  paymentRiskStatus = 'entityCachedData.payment.riskStatus',
  lastDecisionDate = 'lastDecisionDetails.lastDecisionDate',
  lastDecisionMakerId = 'lastDecisionDetails.lastDecisionMakerId',
  lastEscalatedReason = 'lastEscalatedDetails.teamIntegrationId',
  lastEscalatedUserId = 'lastEscalatedDetails.userId',
  label = 'label',
  pendingReason = 'entityCachedData.payment.pendingReason',
  assignedTo = 'assignedTo',
  prioritization = 'prioritization'
}

export const InboxSortMapper = {
  [InboxFilterMapperEnum.scheduledDate]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC]:
      'ascend'
  },
  updatedAt: {
    descend: SortFindManyTaskInput.UPDATEDAT_DESC,
    ascend: SortFindManyTaskInput.UPDATEDAT_ASC,
    [SortFindManyTaskInput.UPDATEDAT_DESC]: 'descend',
    [SortFindManyTaskInput.UPDATEDAT_ASC]: 'ascend'
  },
  [InboxFilterMapperEnum.amount]: {
    descend: SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC]: 'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC]: 'ascend'
  },
  [InboxFilterMapperEnum.organizationCompanyName]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.paymentPartner]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.organizationPartner]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.organizationTaxIdType]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.organizationDecision]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.organizationKybMoneyIn]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.organizationKybMoneyInSubType]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.vendorCompanyName]: {
    descend: SortFindManyTaskInput.ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC]: 'ascend'
  },
  [InboxFilterMapperEnum.fundingSourceId]: {
    descend: SortFindManyTaskInput.ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC]: 'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC]: 'ascend'
  },
  [InboxFilterMapperEnum.deliveryMethodCreatedAt]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.organizationKybStatus]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.paymentId]: {
    descend: SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__ID_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__ID_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__ID_DESC]: 'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__ID_ASC]: 'ascend'
  },
  [InboxFilterMapperEnum.lastDecisionDate]: {
    descend: SortFindManyTaskInput.LASTDECISIONDETAILS__LASTDECISIONDATE_DESC,
    ascend: SortFindManyTaskInput.LASTDECISIONDETAILS__LASTDECISIONDATE_ASC,
    [SortFindManyTaskInput.LASTDECISIONDETAILS__LASTDECISIONDATE_DESC]:
      'descend',
    [SortFindManyTaskInput.LASTDECISIONDETAILS__LASTDECISIONDATE_ASC]: 'ascend'
  },
  [InboxFilterMapperEnum.paymentUserEmail]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC,
    ascend: SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.clientIpAgeForOrganization]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.clientIpAgeForUser]: {
    descend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC,
    ascend:
      SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC,
    [SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC]:
      'descend',
    [SortFindManyTaskInput.ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC]:
      'ascend'
  },
  [InboxFilterMapperEnum.prioritization]: {
    descend: SortFindManyTaskInput.PRIORITIZATION_DESC,
    ascend: SortFindManyTaskInput.PRIORITIZATION_ASC,
    [SortFindManyTaskInput.PRIORITIZATION_DESC]: 'descend',
    [SortFindManyTaskInput.PRIORITIZATION_ASC]: 'ascend'
  }
};
